export const CREATE_PARKING_SLOT = 'CREATE_PARKING_SLOT';
export const EDIT_PARKING_SLOT = 'EDIT_PARKING_SLOT';
export const SHOW_PARKING_SLOT = 'SHOW_PARKING_SLOT';
export const PARKING_SLOT_SUCCESS = 'PARKING_SLOT_SUCCESS';
export const PARKING_SLOT_ERROR = 'PARKING_SLOT_ERROR';

